import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    Pane,
    Paragraph,
    HomeIcon,
    PersonIcon,
    BoxIcon,
    ShopIcon,
    DollarIcon,
    BankAccountIcon,
    DrawIcon,
    PercentageIcon,
    HelpIcon,
    ChartIcon,
    DocumentIcon,
} from 'evergreen-ui';

function SideBar() {
    const location = useLocation();
    const pathname = location.pathname;
    const [isMobile, setIsMobile] = useState(false);

    // Get the base route (first segment after /)
    const baseRoute = pathname.split('/')[1] || 'dashboard';

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Initial check
        checkMobile();

        // Add event listener for window resize
        window.addEventListener('resize', checkMobile);

        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    if (isMobile) {
        return null; // Don't render sidebar on mobile
    }

    return (
        <Pane display="flex" flexDirection="column" marginTop={8}>
            {[
                { route: 'dashboard', icon: HomeIcon, label: 'Home' },
                { route: 'products', icon: DrawIcon, label: 'Products' },
                { route: 'orders', icon: BoxIcon, label: 'Orders' },
                { route: 'customers', icon: ShopIcon, label: 'Customers' },
                { route: 'creators', icon: PersonIcon, label: 'Creators' },
                { route: 'royalties', icon: PercentageIcon, label: 'Royalties' },
                { route: 'royaltypayments', icon: DollarIcon, label: 'Payments' },
                { route: 'statements', icon: DocumentIcon, label: 'Statements' },
                { route: 'expenses', icon: BankAccountIcon, label: 'Expenses' },
                { route: 'reporting', icon: ChartIcon, label: 'Reporting' },
                { route: 'help', icon: HelpIcon, label: 'Help' }
            ].map(({ route, icon: Icon, label }) => (
                <Paragraph
                    key={route}
                    className={baseRoute === route ? 'nav-button-selected' : 'nav-button'}
                >
                    <Link to={`/${route}`}>
                        <Icon size={16} marginRight={10} />
                        {label}
                    </Link>
                </Paragraph>
            ))}
        </Pane>
    );
}

export default SideBar;
